import React from 'react'; // Añade esta línea
import { useEffect, useState } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, PerspectiveCamera } from '@react-three/drei';
//Components
import SponsortsBar from '../../structural/screen/sponsorsBar';
import SponsorBarMobile from '../../structural/screen/sponsorsBarMobile';
import Menu from '../../calculators/wall_brick_clay/menu';
import Inputs from '../../calculators/wall_brick_clay/inputs';
import Panel3D from '../../calculators/wall_brick_clay/3dpanel';
//import StatsPanel from '../../calculators/wall_brick_clay/stats';
//Indexes
import materialesIndex from '../../indexes/materials';
//Database
import materialsDB from '../../databases/materials';

const Wall_Brick_Clay = () => 
{
  // Settings
  const calculatorType = 'bricks';
  const [openMenu, setOpenMenu] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  
  const [selectedBrick, setSelectBrick] = useState(null);
  const [onlyStandardBricks, setOnlyStandardBricks] = useState(null);
  const [onlyHalfBricks, setOnlyHalfBricks] = useState(null);
  const [selectedBrand, setSelectedBrand] = useState(materialesIndex[calculatorType].mainBrand);
  const [bricksDatabase, setBricksDatabase] = useState(null);
  const [mortarGap, setMortarGap] = useState(1); // 1 cm por defecto  

  const [wallDimensions, setWallDimensions] = useState(
  {
    length: 3.45, //metros
    height: 2.30  //metros
  });

  const [brickStats, setBrickStats] = useState(
  {
    totalMortarVolume: 0,
    brickCounts: {
      fullBricks: 0,
      halfBricks: 0,
      incompleteHalfBricks: 0,
      customBricks: []
    },
    totalWeight:0, //en kilos
    linearWeight:0, //kilos por metro

    mortarCost:0, //Costo Total Mortero
    bricksCost:0, //Costo Total Ladrillos
  });

  //Load Database
  useEffect(() => 
  {
    const items = [];

    for (var i=0; i < materialesIndex[calculatorType].brands[selectedBrand].items.length; i++)
    {
      const id = materialesIndex[calculatorType].brands[selectedBrand].items[i];
      const item = materialsDB.find(m => m.id === id);

      items.push(item)
    }

    const standardBricks = items.filter(block => block.properties.subtype === "standard");
    const halfBricks = items.filter(block => block.properties.subtype === "half");

    setSelectBrick(standardBricks[0]);
    setOnlyStandardBricks(standardBricks);
    setOnlyHalfBricks(halfBricks);
    setBricksDatabase(items);
  }, [selectedBrand]);

  //Click Outside Menu
  useEffect(() => 
  {
    const handleClickOutside = () => 
    {
      setOpenMenu(null);
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => 
    {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  //Window Resize
  useEffect(() => 
  {
    const handleResize = () => 
    {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) 
        {
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className = "flex flex-col h-screen">
      
      {/* MENÚ SUPERIOR */}
      <Menu
        title = {"Paredes De Ladrillo Visto"}
        openMenu = {openMenu}
        setOpenMenu = {setOpenMenu}
      />

      {/* CONTENIDO PRINCIPAL */}
      <div className = "flex sm:flex-row flex-col h-full overflow-hidden">
       
        {/* Área de Gráficas / Modelo 3D */}
        <div className = "flex flex-col flex-1 z-50 bg-gray-50 sm:w-9/12 sm:h-full h-1/2">
          
          <div className="flex bg-gray-50 p-1 h-[60px] sm:hidden m-auto">
            <SponsorBarMobile
              calculatorType = {calculatorType}
            />
          </div>

          <div className="h-full w-full border-b-2 sm:border-0 border-black	">
            <Canvas>
              <ambientLight intensity = {0.5} />
              <spotLight position = {[10, 10, 10]} angle = {0.30} penumbra = {1} />
              <spotLight position={[-10, -10, -10]} angle = {0.30} penumbra={1} />
              <directionalLight
                position={[5, 10, 5]}
                intensity={1}
                castShadow
                shadow-mapSize-width={2048}
                shadow-mapSize-height={2048}
                shadow-camera-near={0.1}
                shadow-camera-far={20}
                shadow-camera-left={-10}
                shadow-camera-right={10}
                shadow-camera-top={10}
                shadow-camera-bottom={-10}
              />
              <PerspectiveCamera makeDefault position={[-4, 1, 4]} />
              <OrbitControls enablePan={true} enableZoom={true} enableRotate={true} />
              <Panel3D
                wall = {wallDimensions}
                brick = {selectedBrick} 
                mortarGap = {mortarGap / 100}

                onlyHalfBricks = {onlyHalfBricks}

                setBrickStats   = {setBrickStats}
              />
            </Canvas>
            
            {/*<StatsPanel />*/}
          </div>

          <div className="sm:flex bg-gray-50 p-1 h-[100px] hidden m-auto">
            <SponsortsBar
              calculatorType = {calculatorType}
            />
          </div>
        </div>        

        {/* 🔴 Panel Derecho de Inputs */}        
        <Inputs
          isMobile = {isMobile}
          brands = {materialesIndex[calculatorType].brands}
          setSelectedBrand = {setSelectedBrand}
          database = {bricksDatabase}
          selectedBrick = {selectedBrick}
          setSelectBrick = {setSelectBrick}
          onlyStandardBricks = {onlyStandardBricks}
          wallDimensions = {wallDimensions}
          setWallDimensions = {setWallDimensions}
          mortarGap = {mortarGap}
          setMortarGap = {setMortarGap}

           brickStats = {brickStats}
        />
      </div>

    </div>
  );
};

export default Wall_Brick_Clay;